var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 21.201,
    viewBox: "0 0 26.5 21.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-edit",
    "data-name": "Icon awesome-user-edit",
    d: "M9.275,10.6a5.3,5.3,0,1,0-5.3-5.3A5.3,5.3,0,0,0,9.275,10.6Zm3.71,1.325h-.692a7.208,7.208,0,0,1-6.037,0H5.565A5.567,5.567,0,0,0,0,17.49v1.723A1.988,1.988,0,0,0,1.988,21.2H13.37a1.988,1.988,0,0,1-.108-.882l.282-2.522.05-.46.327-.327,3.2-3.2a5.509,5.509,0,0,0-4.137-1.884Zm1.876,6.016-.282,2.526a.659.659,0,0,0,.729.729l2.522-.282,5.71-5.71-2.969-2.969-5.71,5.706Zm11.35-6.807L24.641,9.565a.992.992,0,0,0-1.4,0L21.677,11.13l-.17.17,2.973,2.969,1.731-1.731a1,1,0,0,0,0-1.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.eef663c1c1fa524f83714b1e06cef07c.svg";
export { ForwardRef as ReactComponent };